import React, { useState } from 'react';
import { MdDelete, MdEdit, MdCheck, MdClose } from 'react-icons/md';
import AddMoreBtn from '../AddMoreBtn';
import { Input } from '../Input/Input';

import classes from './AddMultiValueWithMultipleInput.module.css';

const AddMultiValueWithMultipleInput = ({
  title = 'Default Title',
  firstValueKey = 'title',
  secondValueKey = 'description',
  inputValue,
  inputSetter,
  arrayValue = [],
  arraySetter,
  firstPlaceholder = 'Enter Text',
  secondPlaceholder = 'Enter Text',
  type = 'text',
  hideAddBtn = false,
  firstInputWidth = 49,
  disabled = false,
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState({
    [firstValueKey]: '',
    [secondValueKey]: '',
  });

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditValue({
      [firstValueKey]: arrayValue[index][firstValueKey],
      [secondValueKey]: arrayValue[index][secondValueKey],
    });
  };

  const handleSaveEdit = (index) => {
    if (editValue[firstValueKey].trim() !== '' && editValue[secondValueKey].trim() !== '') {
      const newArray = [...arrayValue];
      newArray[index] = {
        [firstValueKey]: editValue[firstValueKey],
        [secondValueKey]: editValue[secondValueKey],
      };
      arraySetter(newArray);
    }
    setEditingIndex(null);
    setEditValue({
      [firstValueKey]: '',
      [secondValueKey]: '',
    });
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditValue({
      [firstValueKey]: '',
      [secondValueKey]: '',
    });
  };

  const handleDelete = (index) => {
    if (disabled) return;
    let newArray = [...arrayValue];
    newArray.splice(index, 1);
    arraySetter(newArray);
  };

  return (
    <div className={classes?.mainContainer}>
      <div className={[classes?.inputAndAddBtnContainer].join(' ')}>
        <span className={classes?.titleText}>{title}</span>
        {!hideAddBtn && (
          <AddMoreBtn
            onClick={() => {
              if (
                inputValue[firstValueKey] !== '' &&
                inputValue[secondValueKey] !== ''
              ) {
                arraySetter((pre) => [...pre, inputValue]);
                inputSetter({
                  [firstValueKey]: '',
                  [secondValueKey]: '',
                });
              }
            }}
            disabled={disabled}
          />
        )}
      </div>
      <div className={classes?.inputSection}>
        <Input
          disabled={disabled}
          setter={(value) => {
            inputSetter({
              ...inputValue,
              [firstValueKey]: value,
            });
          }}
          value={inputValue[firstValueKey]}
          placeholder={firstPlaceholder}
          type={type}
          parentCustomStyle={{
            width: `${firstInputWidth}%`,
          }}
        />
        <Input
          disabled={disabled}
          setter={(value) => {
            inputSetter({
              ...inputValue,
              [secondValueKey]: value,
            });
          }}
          value={inputValue[secondValueKey]}
          placeholder={secondPlaceholder}
          type={type}
          parentCustomStyle={{
            width: `${98 - firstInputWidth}%`,
          }}
        />
      </div>

      {arrayValue.map((item, index) => (
        <div
          className={[classes.bulletContainer].join(' ')}
          key={`${index} busHighlight`}
        >
          {editingIndex === index ? (
            <>
              <div className={classes.editInputSection}>
                <Input
                  value={editValue[firstValueKey]}
                  setter={(value) => {
                    setEditValue({
                      ...editValue,
                      [firstValueKey]: value,
                    });
                  }}
                  placeholder={firstPlaceholder}
                  type={type}
                  autoFocus={true}
                  parentCustomStyle={{
                    width: `${firstInputWidth}%`,
                  }}
                />
                <Input
                  value={editValue[secondValueKey]}
                  setter={(value) => {
                    setEditValue({
                      ...editValue,
                      [secondValueKey]: value,
                    });
                  }}
                  placeholder={secondPlaceholder}
                  type={type}
                  parentCustomStyle={{
                    width: `${98 - firstInputWidth}%`,
                  }}
                />
              </div>
              <div className={classes.editActions}>
                <MdCheck
                  color={'var(--success-color, #4CAF50)'}
                  size={20}
                  onClick={() => handleSaveEdit(index)}
                  className={classes.actionIcon}
                />
                <MdClose
                  color={'var(--error-color, #f44336)'}
                  size={20}
                  onClick={handleCancelEdit}
                  className={classes.actionIcon}
                />
              </div>
            </>
          ) : (
            <>
              <span className={classes?.keySpan}>{`${item[firstValueKey]} :`}</span>
              <span className={classes?.valueSpan}>{item[secondValueKey]}</span>
              <div className={classes.itemActions}>
                {!disabled && (
                  <MdEdit
                    color={'var(--dashboard-main-color)'}
                    size={18}
                    onClick={() => handleEdit(index)}
                    className={classes.actionIcon}
                  />
                )}
                <MdDelete
                  color={'var(--dashboard-main-color)'}
                  size={20}
                  onClick={() => handleDelete(index)}
                  className={classes.actionIcon}
                />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AddMultiValueWithMultipleInput;
